import type { NavItem } from './app-navigation';
export type WorkDomain =
  'partners' | 'products' | 'sales' | 'purchasing' | 'stock' | 'accounting' | 'other';
export const WORK_DOMAINS: readonly WorkDomain[] = [
  'partners',
  'products',
  'sales',
  'purchasing',
  'stock',
  'accounting',
  'other',
];
export function workDomain(path: string): WorkDomain {
  if (
    /^\/(partners|sales-assistant|crm|contacts)/.test(path) &&
    !path.startsWith('/partners/suppliers')
  )
    return 'partners';
  if (path.startsWith('/products')) return 'products';
  if (/^\/(sales|documents)(\/|$)/.test(path)) return 'sales';
  if (path.startsWith('/procurement/goods-receipts')) return 'stock';
  if (/^\/(procurement|partners\/suppliers)(\/|$)/.test(path)) return 'purchasing';
  if (/^\/(inventory|picking|delivery|driver|reusable|returns|stock)/.test(path)) return 'stock';
  if (/^\/(finance|accounting|electronic-invoices)/.test(path)) return 'accounting';
  return 'other';
}
/** Group already permission- and feature-filtered entries without inventing new access rules. */
export function groupWorkNavigation(
  items: readonly NavItem[],
): readonly { id: WorkDomain; items: readonly NavItem[] }[] {
  const entries: NavItem[] = [];
  for (const item of items) {
    const moved =
      item.children?.filter(
        (child) => workDomain(child.to) === 'stock' && workDomain(item.to) !== 'stock',
      ) ?? [];
    const children = item.children?.filter((child) => !moved.includes(child));
    entries.push(children === undefined ? item : { ...item, children });
    entries.push(...moved);
  }
  return WORK_DOMAINS.map((id) => ({
    id,
    items: entries.filter((item) => workDomain(item.to) === id),
  })).filter((group) => group.items.length > 0);
}
